import React from 'react';

import { Props } from 'types/pages/Auction_View/partials//auctionBidding';
import { AuctionPrice } from 'components';

const Price: React.FC<Pick<Props, 'price'>> = ({ price }) => (price !== null ? <AuctionPrice price={price} /> : null);

export default Price;
